import rules from './rulesContent/Regulament-pariuri.pdf';


export default {
    termsAndConditions: [
        {
            'title': {
                'eng': 'Rules',
                'rum': "Regulament de Joc"
            },
            'hasSubTabs': false,
            'textTranslationKey': {
                'eng': `<div><embed src="${rules}#toolbar=0&navpanes=0&scrollbar=0&zoom=108" type="application/pdf" width="890px" height="600px" /></div>`,
            }
        }
    ]
};
